export default function Projectcard(props) {
  return (
    <div className='col-lg-4 col-md-6 col-12 m-b'>
      <div className="box-wrapper project">
        <img src={props.icon} alt={props.text} className="img-size" />
        <div className="custom-overlay">{props.des}</div>
      </div>
      <div className="mb-3"><a className="link-color" target="_blank" href={props.link}>{props.name}</a></div>
    </div>
  );
  
}